import PropTypes from 'prop-types'
import {
  StyledContainer,
  CreditPill,
  StyledCurrentValue,
  StyledMaxValue,
  GaugeSection,
  GaugeSegments,
  GaugeSegment,
  QuestList,
} from './styled-components'
import useCreditBoosterContent from './useCreditBoosterContent'
import SaleQuest from './SaleQuest/SaleQuest'
import ModuleToggle from '@/containers/SubscriptionFormPageNew/Components/shared/ModuleCollapse/ModuleToggle'
import ModuleHeading from '@/containers/SubscriptionFormPageNew/Components/shared/ModuleCollapse/ModuleHeading'
import { HeaderActions } from '@/containers/SubscriptionFormPageNew/Components/shared/ModuleCollapse/styled-components'
import ModuleHeader from '@/containers/SubscriptionFormPageNew/Components/shared/ModuleCollapse/ModuleHeader'
import IconCarbonRocket from '@/shared/icons/IconCarbonRocket'

const CreditBoosterContent = ({ t, scriptArray, scrollToAdditionalSaleTab }) => {
  const { expanded, toggle, panelExpanded, quests, segments, addLabel, soldCount, saleCount, completed } =
    useCreditBoosterContent({
      t,
      scriptArray,
      onOpenSale: scrollToAdditionalSaleTab,
    })

  return (
    <StyledContainer $completed={completed}>
      <ModuleHeader clickable onClick={toggle}>
        <ModuleHeading icon={IconCarbonRocket} moduleKey='credit-booster'>
          {t('subscriptionForm:credit_booster.title')}
        </ModuleHeading>
        <HeaderActions>
          <CreditPill $completed={completed} title={t('subscriptionForm:credit_booster.sales_count')}>
            <StyledCurrentValue $reachedMax={completed}>{soldCount}</StyledCurrentValue>
            <StyledMaxValue>/{saleCount}</StyledMaxValue>
          </CreditPill>
          <ModuleToggle expanded={expanded} onToggle={toggle} moduleKey='credit-booster' />
        </HeaderActions>
      </ModuleHeader>
      <GaugeSection hidden={!panelExpanded}>
        <GaugeSegments>
          {segments.map(sale => (
            <GaugeSegment key={sale.name} $sold={sale.sold} />
          ))}
        </GaugeSegments>
      </GaugeSection>
      <QuestList $hidden={!expanded}>
        {quests.map(quest => (
          <SaleQuest key={quest.name} quest={quest} addLabel={addLabel} />
        ))}
      </QuestList>
    </StyledContainer>
  )
}

CreditBoosterContent.propTypes = {
  t: PropTypes.func,
  scriptArray: PropTypes.arrayOf(PropTypes.object),
  scrollToAdditionalSaleTab: PropTypes.func,
}

export default CreditBoosterContent
